import React from 'react';

import DefaultTree from './DefaultTree';
import MEDDRATree from './MEDDRATree';

const RegulatoryTermsTree = ({ type, ...props }) =>
  type === 'MEDDRA' ? <MEDDRATree {...props} /> : <DefaultTree {...props} type={type} />;

export default RegulatoryTermsTree;
